let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("EfZ3g")).then(() => parcelRequire('gEAAx'));